<template>
  <div class="modal warning fade" :class="{ 'is-open': open }">
    <div class="modal-dialog">
      <div class="modal-content">
        <a class="close" @click="$emit('close')">
          <i class="icon-close"></i>
        </a>

        <div class="modal-body">
          <div class="warning text-style">請選擇歸戶方式</div>
          <div class="action text-right">
            <a @click="addToFamily" class="btn btn-primary">加入現有家戶</a>
            <a @click="createNewFamily" class="btn btn-primary">建立新的家戶</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAllHouseholderBySales } from "@/service";
export default {
  name: "bkmvAddFamilyModal",
  data() {
    return {
      getAllHouseholderBySalesResult: [],
      //是否為保代用頁面
      isFromBank: true,
    };
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    csidno: {
      type: String,
      default: "",
    },
  },
  methods: {
    addToFamily() {
      getAllHouseholderBySales(
        this.$store.state.userInfo.id,
        this.isFromBank
      ).then((result) => {
        this.getAllHouseholderBySalesResult = result.data;
        this.getAllHouseholderBySalesResult = this.getAllHouseholderBySalesResult.filter(
          (item) => item.csidno != this.csidno
        );
        //若完全沒有任何家戶，點擊後返回前頁，並顯示警示訊息「沒有可以加入的家戶」
        if (
          !this.getAllHouseholderBySalesResult ||
          this.getAllHouseholderBySalesResult.length === 0
        ) {
          this.$toast.info({ title: "沒有可以加入的家戶" });
          return;
        } else {
          this.$router.push({
            name: "bkAddToFamily",
            params: {
              isReAddFamily: true,
            },
          });
          this.$emit("close");
        }
      });
    },
    createNewFamily() {
      this.$router.push({ name: "createBKNewFamily" });
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.close {
  position: absolute;
  font-size: 16px;
  width: 24px;
  height: 24px;
  right: 0;
  top: 0;
  margin-right: -12px;
  margin-top: -12px;
  display: block;
  color: #fff;
  text-align: center;
  line-height: 24px;
  padding: 0;
  background: #5b616a;
  border: 1px solid #fff;
  border-radius: 12px;
  -webkit-box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.8);
  -ms-box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.8);
  -o-box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.8);
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.8);
}
.text-style {
  width: 140px;
  height: 33px;
  font-family: PingFangTC;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.65;
  letter-spacing: normal;
  color: #323a45;
  margin-top: 25px;
  margin-bottom: 80px;
}
</style>
